import { TermsAndConditionsPage } from './TermsAndConditionsPage';

export default TermsAndConditionsPage;
